import * as React from "react"
import type { SVGProps } from "react"
const SvgQuestionCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.95 18.86q.53 0 .89-.37.36-.36.36-.88c0-.52-.12-.65-.36-.89a1.2 1.2 0 0 0-.89-.36q-.53 0-.89.36a1.2 1.2 0 0 0-.36.89q0 .52.36.88.36.37.89.37m.05 4a10 10 0 0 1-3.9-.79 10 10 0 0 1-3.17-2.14 10 10 0 0 1-2.14-3.17 10 10 0 0 1-.79-3.9q0-2.08.79-3.9a10 10 0 0 1 2.13-3.18Q6.28 4.43 8.1 3.65a10 10 0 0 1 3.9-.8q2.07 0 3.9.8a10 10 0 0 1 3.18 2.13q1.34 1.35 2.13 3.18a10 10 0 0 1 .79 3.9 10 10 0 0 1-.79 3.9 10 10 0 0 1-2.14 3.17q-1.34 1.35-3.17 2.14a10 10 0 0 1-3.9.79m0-2q3.35 0 5.68-2.33A7.7 7.7 0 0 0 20 12.86q0-3.36-2.33-5.68A7.7 7.7 0 0 0 12 4.86q-3.34 0-5.67 2.32A7.7 7.7 0 0 0 4 12.86q0 3.34 2.33 5.67A7.7 7.7 0 0 0 12 20.86m.1-12.3q.63 0 1.09.4t.46 1q0 .54-.34.97t-.76.8q-.57.5-1.01 1.1t-.44 1.35q0 .35.26.59.27.24.62.24a1 1 0 0 0 .63-.25q.27-.25.34-.63.1-.52.45-.94c.35-.42.48-.53.75-.78q.57-.55.99-1.2a2.7 2.7 0 0 0 .41-1.45q0-1.28-1.04-2.09a3.8 3.8 0 0 0-2.41-.81q-.95 0-1.81.4a2.8 2.8 0 0 0-1.32 1.22 1 1 0 0 0-.1.64.7.7 0 0 0 .33.51q.35.2.72.13a1 1 0 0 0 .63-.43q.27-.37.69-.57.4-.2.86-.2" />
  </svg>
)
export default SvgQuestionCircle
